module.exports = __webpack_public_path__ + "img/user.dc8b1732.png";